import { useFetcher, useParams } from '@remix-run/react';
import { useTranslation } from 'react-i18next';

import Button from '~/components/Button';

import useToast from '~/hooks/useToast';

import StatusInputs from '../Forms/StatusInputs';

const FeedbackAction = ({ pcid, ppid, sid, redirectLink }: any) => {
  const fetcher = useFetcher();
  const fetcherData = fetcher.data;
  const params = useParams();
  const isSubmitting = fetcher.state === 'submitting';
  const { t } = useTranslation();

  useToast(fetcherData?.toast);

  return (
    <fetcher.Form method="post" action={'/extended_feedback'}>
      <input hidden name="poll_id" value={params?.pollId} onChange={() => null} />
      <input hidden name="ppid" value={ppid} onChange={() => null} />
      <input hidden name="pcid" value={pcid} onChange={() => null} />
      <input hidden name="sid" value={sid} onChange={() => null} />
      <input hidden name="redirectLink" defaultValue={redirectLink} />
      <StatusInputs
        name="extended_feedback"
        errorMessage={t('errors.default')}
        successMessage={t('polls.extended_feedback.success')}
      />
      <label className="block text-sm font-medium text-gray-700" htmlFor="extended_feedback">
        {t('feedback.additional')}
      </label>
      <textarea
        className="mb-8 mt-1 block w-full rounded-md border border-gray-300 bg-gray-100 px-3 py-2 placeholder-gray-400 focus:border-wt-primary focus:outline-none"
        placeholder={`${t('feedback.placeholder')}...` || ''}
        name="extended_feedback"
        rows={5}
      />
      <div className="flex w-full justify-end">
        <div className="w-full">
          <Button type="submit" variant="primary" className="flex w-full justify-center" isLoading={isSubmitting}>
            {isSubmitting ? `${t('shared.actions.submitting')}...` : t('shared.cta.continue')}
          </Button>
        </div>
      </div>
    </fetcher.Form>
  );
};

export default FeedbackAction;
